export default "__VITE_ASSET__RX7UgNWA__"